import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAcorn as fadAcorn,
  faAlienMonster as fadAlienMonster,
  faBars as fadBars,
  faBluetooth as fadBluetooth,
  faBreadSlice as fadBreadSlice,
  faCalendarCheck as fadCalendarCheck,
  faCamera as fadCamera,
  faCarrot as fadCarrot,
  faCog as fadCog,
  faCopy as fadCopy,
  faCow as fadCow,
  faEgg as fadEgg,
  faEggFried as fadEggFried,
  faEllipsisV as fadEllipsisV,
  faEnvelope as fadEnvelope,
  faFish as fadFish,
  faGrid as fadGrid,
  faHome as fadHome,
  faLock as fadLock,
  faPeanuts as fadPeanuts,
  faPhone as fadPhone,
  faPig as fadPig,
  faRobot as fadRobot,
  faSalad as fadSalad,
  faSeedling as fadSeedling,
  faSheep as fadSheep,
  faShoppingBasket as fadShoppingBasket,
  faShrimp as fadShrimp,
  faSignOut as fadSignOut,
  faStar as fadStar,
  faSteak as fadSteak,
  faTasks as fadTasks,
  faTh as fadTh,
  faTrophy as fadTrophy,
  faTrophyAlt as fadTrophyAlt,
  faTurkey as fadTurkey,
  faUser as fadUser,
  faWheat as fadWheat,
} from '@fortawesome/pro-duotone-svg-icons';
import {
  faBars as falBars,
  faCalendarCheck as falCalendarCheck,
  faCog as falCog,
  faCopy as falCopy,
  faEllipsisV as falEllipsisV,
  faRobot as falRobot,
  faSalad as falSalad,
  faSignOut as falSignOut,
  faStar as falStar,
  faTasks as falTasks,
  faTrophy as falTrophy,
  faTrophyAlt as falTrophyAlt,
  faUser as falUser,
} from '@fortawesome/pro-light-svg-icons';
import {
  faAlienMonster as farAlienMonster,
  faArrowUp as farArrowUp,
  faBars as farBars,
  faBluetooth as farBluetooth,
  faCalendarCheck as farCalendarCheck,
  faCalendarDay as farCalendarDay,
  faCalendarPlus as farCalendarPlus,
  faChartLine as farChartLine,
  faChartLineDown as farChartLineDown,
  faCheck as farCheck,
  faCheckCircle as farCheckCircle,
  faCheckSquare as farCheckSquare,
  faChevronDown as farChevronDown,
  faChevronLeft as farChevronLeft,
  faChevronRight as farChevronRight,
  faChevronUp as farChevronUp,
  faCircle as farCircle,
  faClock as farClock,
  faCog as farCog,
  faCopy as farCopy,
  faDollarSign as farDollarSign,
  faEdit as farEdit,
  faEllipsisV as farEllipsisV,
  faEnvelope as farEnvelope,
  faExchange as farExchange,
  faExclamationTriangle as farExclamationTriangle,
  faGrid as farGrid,
  faHatChef as farHatChef,
  faHeart as farHeart,
  faHome as farHome,
  faLoader as farLoader,
  faLock as farLock,
  faMapMarkerAlt as farMapMarkerAlt,
  faMicrophone as farMicrophone,
  faMinus as farMinus,
  faPaperPlane as farPaperPlane,
  faPlay as farPlay,
  faPlus as farPlus,
  faRandom as farRandom,
  faRobot as farRobot,
  faSalad as farSalad,
  faShareAlt as farShareAlt,
  faSignOut as farSignOut,
  faSlidersH as farSlidersH,
  faSmile as farSmile,
  faSmilePlus as farSmilePlus,
  faSquare as farSquare,
  faStar as farStar,
  faStickyNote as farStickyNote,
  faSync as farSync,
  faTasks as farTasks,
  faTh as farTh,
  faThumbsUp as farThumbsUp,
  faTimes as farTimes,
  faTimesCircle as farTimesCircle,
  faTrash as farTrash,
  faTrophy as farTrophy,
  faTrophyAlt as farTrophyAlt,
  faUser as farUser,
  faUserFriends as farUserFriends,
  faUtensils as farUtensils,
  faVolume as farVolume,
  faWandMagicSparkles as farWandMagicSparkles,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faAlarmClock as fasAlarmClock,
  faAlienMonster as fasAlienMonster,
  faAllergies as fasAllergies,
  faAnalytics as fasAnalytics,
  faAppleWhole as fasAppleWhole,
  faArrowLeft as fasArrowLeft,
  faArrowRotateLeft as fasArrowRotateLeft,
  faArrowRotateRight as fasArrowRotateRight,
  faBacon as fasBacon,
  faBan as fasBan,
  faBars as fasBars,
  faBluetooth as fasBluetooth,
  faBell as fasBell,
  faBowlHot as fasBowlHot,
  faBreadLoaf as fasBreadLoaf,
  faBreadSlice as fasBreadSlice,
  faCalendar as fasCalendar,
  faCalendarCheck as fasCalendarCheck,
  faCalendarDay as fasCalendarDay,
  faCamera as fasCamera,
  faCarrot as fasCarrot,
  faCheck as fasCheck,
  faCheckCircle as fasCheckCircle,
  faCheckSquare as fasCheckSquare,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronRight as fasChevronRight,
  faChevronUp as fasChevronUp,
  faCircle as fasCircle,
  faClock as fasClock,
  faCode as fasCode,
  faCog as fasCog,
  faCoins as fasCoins,
  faCommentAltLines as fasCommentAltLines,
  faCommentLines as fasCommentLines,
  faCopy as fasCopy,
  faCow as fasCow,
  faDeleteLeft as fasDeleteLeft,
  faDownload as fasDownload,
  faDrumstick as fasDrumstick,
  faEdit as fasEdit,
  faEllipsisV as fasEllipsisV,
  faEnvelope as fasEnvelope,
  faExclamationTriangle as fasExclamationTriangle,
  faExternalLinkAlt as fasExternalLinkAlt,
  faFaceFrown as fasFaceFrown,
  faFaceMeh as fasFaceMeh,
  faFish as fasFish,
  faGrid as fasGrid,
  faHatChef as fasHatChef,
  faHeart as fasHeart,
  faHouse as fasHouse,
  faImagePolaroid as fasImagePolaroid,
  faInfoCircle as fasInfoCircle,
  faKey as fasKey,
  faLoader as fasLoader,
  faLock as fasLock,
  faMapMarkerAlt as fasMapMarkerAlt,
  faMaximize as fasMaximize,
  faMeat as fasMeat,
  faMicrophone as fasMicrophone,
  faMinus as fasMinus,
  faMoneyBills as fasMoneyBills,
  faMugHot as fasMugHot,
  faMugSaucer as fasMugSaucer,
  faMugTeaSaucer as fasMugTeaSaucer,
  faPalette as fasPalette,
  faPaperPlane as fasPaperPlane,
  faPause as fasPause,
  faPencil as fasPencil,
  faPhone as fasPhone,
  faPiggyBank as fasPiggyBank,
  faPlay as fasPlay,
  faPlayCircle as fasPlayCircle,
  faPlus as fasPlus,
  faQuestionCircle as fasQuestionCircle,
  faRobot as fasRobot,
  faRotate as fasRotate,
  faSalad as fasSalad,
  faSearch as fasSearch,
  faSteeringWheel as fasSteeringWheel,
  faShareAlt as fasShareAlt,
  faShishKebab as fasShishKebab,
  faShoppingBasket as fasShoppingBasket,
  faSignOut as fasSignOut,
  faSmile as fasSmile,
  faSmilePlus as fasSmilePlus,
  faStar as fasStar,
  faStars as fasStars,
  faSteak as fasSteak,
  faStickyNote as fasStickyNote,
  faStop as fasStop,
  faSunCloud as fasSunCloud,
  faTablet as fasTablet,
  faTags as fasTags,
  faTasks as fasTasks,
  faTh as fasTh,
  faThumbsDown as fasThumbsDown,
  faThumbsUp as fasThumbsUp,
  faTimer as fasTimer,
  faTimes as fasTimes,
  faTimesCircle as fasTimesCircle,
  faTrash as fasTrash,
  faTrophy as fasTrophy,
  faTrophyAlt as fasTrophyAlt,
  faTurkey as fasTurkey,
  faUndo as fasUndo,
  faUpRightAndDownLeftFromCenter as fasUpRightAndDownLeftFromCenter,
  faUpload as fasUpload,
  faUsdCircle as fasUsdCircle,
  faUser as fasUser,
  faUserChef as fasUserChef,
  faUserFriends as fasUserFriends,
  faUtensils as fasUtensils,
  faVideo as fasVideo,
  faVideoPlus as fasVideoPlus,
  faVolume as fasVolume,
  faWheat as fasWheat,
} from '@fortawesome/pro-solid-svg-icons';

// map default icon style
const faCalendarDay = farCalendarDay;
const faCheck = fasCheck;
const faChevronDown = fasChevronDown;
const faChevronLeft = fasChevronLeft;
const faChevronRight = fasChevronRight;
const faChevronUp = fasChevronUp;
const faCog = fasCog;
const faEdit = fasEdit;
const faMapMarkerAlt = fasMapMarkerAlt;
const faPlus = fasPlus;
const faRobot = fasRobot;
const faSalad = fasSalad;
const faSignOut = fasSignOut;
const faSmile = fasSmile;
const faSmilePlus = fasSmilePlus;
const faStickyNote = fasStickyNote;
const faTablet = fasTablet;
const faTasks = fasTasks;
const faTimes = fasTimes;
const faTimesCircle = fasTimesCircle;
const faTrash = fasTrash;
const faTrophy = fasTrophy;
const faTrophyAlt = fasTrophyAlt;
const faUser = fasUser;
const faUserFriends = fasUserFriends;
const faPaperPlane = fasPaperPlane;
const faMicrophone = fasMicrophone;
const faVolume = fasVolume;
const faBars = fasBars;
const faBluetooth = fasBluetooth;
const faCamera = fasCamera;
const faEllipsisV = falEllipsisV;
const faHatChef = farHatChef;
const faSearch = fasSearch;
const faSteeringWheel = fasSteeringWheel;
const faPlay = farPlay;
const faPlayCircle = fasPlayCircle;
const faArrowUp = farArrowUp;
const faCopy = fasCopy;
const faStar = fasStar;
const faUtensils = fasUtensils;
const faAlienMonster = fasAlienMonster;
const faSync = farSync;
const faUpload = fasUpload;
const faImagePolaroid = fasImagePolaroid;
const faCircle = fasCircle;
const faCalendarPlus = farCalendarPlus;
const faSteak = fadSteak;
const faPig = fadPig;
const faTurkey = fadTurkey;
const faFish = fadFish;
const faSheep = fadSheep;
const faEggFried = fadEggFried;
const faWheat = fadWheat;
const faCow = fadCow;
const faSeedling = fadSeedling;
const faBreadSlice = fadBreadSlice;
const faDollarSign = farDollarSign;
const faShoppingBasket = fasShoppingBasket;
const faHome = farHome;
const faExclamationTriangle = fasExclamationTriangle;
const faHeart = farHeart;
const faExchange = farExchange;
const faSlidersH = farSlidersH;
const faRandom = farRandom;
const faMinus = fasMinus;
const faAnalytics = fasAnalytics;
const faExternalLinkAlt = fasExternalLinkAlt;
const faVideoPlus = fasVideoPlus;
const faTh = farTh;
const faThumbsUp = fasThumbsUp;
const faShareAlt = fasShareAlt;
const faCarrot = fasCarrot;
const faUsdCircle = fasUsdCircle;
const faBan = fasBan;
const faAllergies = fasAllergies;
const faWandMagicSparkles = farWandMagicSparkles;

/**
 * Load all the fonts we'll need from fontAwesome here
 */
export const loadFonts = (): void => {
  library.add(
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCog,
    faEdit,
    faPlus,
    faRobot,
    faSalad,
    faSignOut,
    faSmile,
    faSmilePlus,
    faStickyNote,
    faTablet,
    faTasks,
    faTimes,
    faTimesCircle,
    faTrash,
    faTrophy,
    faTrophyAlt,
    faMapMarkerAlt,
    faUserFriends,
    faUser,
    faPaperPlane,
    faMicrophone,
    faVolume,
    faBars,
    faBluetooth,
    faCamera,
    faEllipsisV,
    faHatChef,
    faSearch,
    faSteeringWheel,
    faPlay,
    faPlayCircle,
    faArrowUp,
    faCopy,
    faStar,
    faUtensils,
    faAlienMonster,
    faSync,
    faUpload,
    faImagePolaroid,
    faCircle,
    faCalendarPlus,
    faCalendarDay,
    faSteak,
    faPig,
    faTurkey,
    faFish,
    faSheep,
    faEggFried,
    faWheat,
    faCow,
    faSeedling,
    faBreadSlice,
    faCarrot,
    faDollarSign,
    faShoppingBasket,
    faHome,
    faExclamationTriangle,
    faHeart,
    faExchange,
    faSlidersH,
    faRandom,
    faMinus,
    faAnalytics,
    faExternalLinkAlt,
    faVideoPlus,
    faTh,
    faThumbsUp,
    faShareAlt,
    faCarrot,
    faUsdCircle,
    faBan,
    faAllergies,
    faWandMagicSparkles,

    // duotone
    fadCog,
    fadCalendarCheck,
    fadRobot,
    fadSalad,
    fadSignOut,
    fadTasks,
    fadTrophy,
    fadTrophyAlt,
    fadUser,
    fadBars,
    fadEnvelope,
    fadBluetooth,
    fadBars,
    fadEllipsisV,
    fadCopy,
    fadStar,
    fadAlienMonster,
    fadSteak,
    fadPig,
    fadTurkey,
    fadFish,
    fadSheep,
    fadEggFried,
    fadWheat,
    fadCow,
    fadSeedling,
    fadBreadSlice,
    fadCarrot,
    fadShoppingBasket,
    fadHome,
    fadTh,
    fadEgg,
    fadShrimp,
    fadAcorn,
    fadPeanuts,
    fadGrid,
    fadLock,
    fadPhone,
    fadCamera,

    // light
    falCalendarCheck,
    falCog,
    falRobot,
    falSalad,
    falSignOut,
    falTasks,
    falTrophy,
    falTrophyAlt,
    falUser,
    falBars,
    falEllipsisV,
    falCopy,
    falStar,

    // regular
    farCalendarCheck,
    farCheck,
    farCheckCircle,
    farCheckSquare,
    farChevronDown,
    farChevronLeft,
    farChevronRight,
    farChevronUp,
    farCircle,
    farClock,
    farCog,
    farEdit,
    farMapMarkerAlt,
    farPlus,
    farRobot,
    farSalad,
    farSignOut,
    farSmile,
    farSmilePlus,
    farSquare,
    farStickyNote,
    farTasks,
    farTimes,
    farTimesCircle,
    farTrash,
    farTrophy,
    farTrophyAlt,
    farUser,
    farUserFriends,
    farPaperPlane,
    farMicrophone,
    farVolume,
    farEnvelope,
    farBars,
    farBluetooth,
    farChartLine,
    farChartLineDown,
    farHatChef,
    farEllipsisV,
    farPlay,
    farArrowUp,
    farCopy,
    farStar,
    farUtensils,
    farAlienMonster,
    farCalendarPlus,
    farCalendarDay,
    farDollarSign,
    farHome,
    farExclamationTriangle,
    farHeart,
    farExchange,
    farSlidersH,
    farRandom,
    farMinus,
    farTh,
    farThumbsUp,
    farShareAlt,
    farGrid,
    farLoader,
    farLock,

    // Solid
    fasCalendarCheck,
    fasCheck,
    fasCheckCircle,
    fasCheckSquare,
    fasChevronDown,
    fasChevronLeft,
    fasChevronRight,
    fasChevronUp,
    fasClock,
    fasCog,
    fasEdit,
    fasMapMarkerAlt,
    fasPlus,
    fasRobot,
    fasSalad,
    fasSignOut,
    fasSmile,
    fasSmilePlus,
    fasStickyNote,
    fasTasks,
    fasTimes,
    fasTimesCircle,
    fasTrash,
    fasTrophy,
    fasTrophyAlt,
    fasUser,
    fasUserFriends,
    fasPaperPlane,
    fasMicrophone,
    fasVolume,
    fasEnvelope,
    fasBars,
    fasBluetooth,
    fasCamera,
    fasHatChef,
    fasSearch,
    fasEllipsisV,
    fasPlayCircle,
    fasCopy,
    fasStar,
    fasUtensils,
    fasAlienMonster,
    fasUpload,
    fasImagePolaroid,
    fasCircle,
    fasCommentAltLines,
    fasCalendarDay,
    fasShoppingBasket,
    fasExclamationTriangle,
    fasHeart,
    fasPhone,
    fasVideo,
    fasCommentLines,
    fasAnalytics,
    fasTh,
    fasThumbsUp,
    fasShareAlt,
    fasCarrot,
    fasUsdCircle,
    fasBan,
    fasAllergies,
    fasMinus,
    fasCow,
    fasMeat,
    fasWheat,
    fasFish,
    fasBacon,
    fasBreadLoaf,
    fasSteak,
    fasDownload,
    fasRotate,
    fasLoader,
    fasLock,
    fasUndo,
    fasPlay,
    fasQuestionCircle,
    fasBell,
    fasCalendar,
    fasPalette,
    fasInfoCircle,
    fasPause,
    fasArrowRotateLeft,
    fasArrowRotateRight,
    fasStop,
    fasCode,
    fasHouse,
    fasGrid,
    fasPencil,
    fasArrowLeft,
    fasStars,
    fasTimer,
    fasSunCloud,
    fasPiggyBank,
    fasCoins,
    fasMoneyBills,
    fasTurkey,
    fasDrumstick,
    fasShishKebab,
    fasAppleWhole,
    fasBowlHot,
    fasMugSaucer,
    fasMugTeaSaucer,
    fasMugHot,
    fasAlarmClock,
    fasBreadSlice,
    fasUserChef,
    fasDeleteLeft,
    fasFaceMeh,
    fasFaceFrown,
    fasThumbsDown,
    fasUpRightAndDownLeftFromCenter,
    fasMaximize,
    fasKey,
    fasTags
  );
};
